import React from 'react'

import { usePatchCSNoteMutation } from 'api/notes/configuredServiceNotesCrud'
import ViewArchiveNotesDialog from 'components/notes/common/ViewArchiveNotesDialog'
import T from 'T'

type CSViewArchiveNotesDialogProps = Omit<React.ComponentProps<typeof ViewArchiveNotesDialog>, 'title' | 'useUnarchiveNoteMutation'>

const CSViewArchiveNotesDialog = (props: CSViewArchiveNotesDialogProps) => (
  <ViewArchiveNotesDialog {...props} title={T.ARCHIVED_CONFIGURED_SERVICE_NOTES} useUnarchiveNoteMutation={usePatchCSNoteMutation} />
)

export default CSViewArchiveNotesDialog
